module.exports = "/_next/static/resources/photo-2-5e5a3aa1a574c0ec993817e70f4269a3.jpg";